import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
interface ButtonProps {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
  size?: 'sm' | 'md' | 'lg';
  arrow?: boolean;
  className?: string;
  fullWidth?: boolean;
  external?: boolean;
}
export function Button({
  children,
  href,
  onClick,
  variant = 'primary',
  size = 'lg',
  arrow = false,
  className = '',
  fullWidth = false,
  external = true
}: ButtonProps) {
  const sizeClasses = {
    sm: 'px-5 py-2.5 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const baseClasses = `relative group inline-flex items-center justify-center gap-2 rounded-full font-bold transition-all duration-300 ${sizeClasses[size]} ${fullWidth ? 'w-full' : ''}`;
  const variantClasses = {
    primary: 'bg-blue-600 text-white hover:bg-blue-700 hover:scale-105 shadow-lg shadow-blue-600/20',
    secondary: 'bg-white text-slate-700 hover:text-slate-900 hover:scale-105 shadow-lg shadow-slate-900/5 border border-slate-200 hover:border-slate-300'
  };
  const glowClasses = {
    primary: 'bg-blue-400 opacity-0 group-hover:opacity-20',
    secondary: 'bg-slate-300 opacity-0 group-hover:opacity-15'
  };
  const content = <>
      <motion.div animate={{
      scale: [1, 1.05, 1]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      repeatType: 'reverse'
    }} className={`absolute inset-0 rounded-full blur-xl ${glowClasses[variant]}`} data-id="element-6285" />
      <span className="relative z-10 flex items-center gap-2" data-id="element-6286">
        {children}
        {arrow && <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-0.5 transition-transform" data-id="element-6287" />}
      </span>
    </>;
  if (href) {
    return <a href={href} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} className={`${baseClasses} ${variantClasses[variant]} ${className}`} data-id="element-6288">
        {content}
      </a>;
  }
  return <button onClick={onClick} className={`${baseClasses} ${variantClasses[variant]} ${className}`} data-id="element-6289">
      {content}
    </button>;
}